import { render, staticRenderFns } from "./DetalheAlerta.vue?vue&type=template&id=59674160&scoped=true"
import script from "./DetalheAlerta.vue?vue&type=script&lang=js"
export * from "./DetalheAlerta.vue?vue&type=script&lang=js"
import style0 from "./DetalheAlerta.vue?vue&type=style&index=0&id=59674160&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59674160",
  null
  
)

export default component.exports